import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './CardBody.css';

const propTypes = {
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

const defaultProps = {
  className: undefined,
  tag: 'div',
};

const CardBody = ({ className, tag: Tag, ...other }) => {
  const classes = classNames(className, 'apollo-card-body');
  return <Tag {...other} className={classes} />;
};

CardBody.propTypes = propTypes;
CardBody.defaultProps = defaultProps;

export default CardBody;
